{
  "version": 1,
  "asset_id": "898a7f12-5a3d-44b3-ae19-35146eaa350f",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/898a7f12-5a3d-44b3-ae19-35146eaa350f/beverly-hills-shingle-roof-underlayment-768w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/898a7f12-5a3d-44b3-ae19-35146eaa350f/beverly-hills-shingle-roof-underlayment-768w.avif",
  "original_filename": "beverly-hills-shingle-roof-underlayment-768w.avif",
  "size": 40881,
  "content_type": "image/avif",
  "created_at": "2026-07-29T14:06:58Z"
}
